import SessionActionTypeEnum from './SessionConstants';

const SessionHandler = (state, action = {}) => {
  if (typeof state === 'undefined') {
    return {
      isSaving: false,
      isAutoSavingEnabled: false,
      lastAutoSaveValue: null,
    };
  }

  switch (action.type) {
    case SessionActionTypeEnum.SET_SESSION_AUTO_SAVE_VALUE:
      return Object.assign({}, state, { lastAutoSaveValue: JSON.stringify(action.autoSaveValue) });
    case SessionActionTypeEnum.SAVE_SESSION_CONTENT_REQUEST:
    case SessionActionTypeEnum.SAVE_SESSION_REQUEST:
      return Object.assign({}, state, { isSaving: true });
    case SessionActionTypeEnum.SAVE_OWNER_CONTENT_SUCCESS:
    case SessionActionTypeEnum.SAVE_SHARED_CONTENT_SUCCESS:
    case SessionActionTypeEnum.SAVE_SESSION_SUCCESS:
      return Object.assign({}, state, {
        isSaving: false,
        lastAutoSaveValue: JSON.stringify(action.autoSaveValue),
      });
    case SessionActionTypeEnum.SAVE_OWNER_CONTENT_FAILURE:
    case SessionActionTypeEnum.SAVE_SHARED_CONTENT_FAILURE:
    case SessionActionTypeEnum.SAVE_SESSION_CONTENT_PASS:
    case SessionActionTypeEnum.SAVE_SESSION_FAILURE:
      return Object.assign({}, state, { isSaving: false });
    case SessionActionTypeEnum.START_AUTO_SAVE:
      return Object.assign({}, state, { isAutoSavingEnabled: true });
    case SessionActionTypeEnum.STOP_AUTO_SAVE:
      return Object.assign({}, state, {
        isAutoSavingEnabled: false,
      });
    default:
      return state;
  }
};

export default SessionHandler;



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/Session/SessionReducer.jsx